import PropTypes from 'prop-types';
import { makeStyles } from '@mui/styles';
import HelpOutlineOutlinedIcon from '@mui/icons-material/Help';

const useStyles = makeStyles(() => ({
  iconRoot: {
    width: ({ size }) => `${size}px`,
    height: ({ size }) => `${size}px`,
    cursor: ({ hasAction }) => hasAction && 'pointer'
  },
  informationDialogButton: {
    width: ({ size }) => `${size}px`,
    height: ({ size }) => `${size}px`,
    color: ({ color }) => color || 'inherit',

    '&:hover': {
      color: ({ hoverColor }) => hoverColor || 'inherit',
      cursor: ({ hasAction }) => hasAction && 'pointer'
    }
  }
}));

const noop = () => {};

const HelperIcon = ({ action = noop, size = 20, color = '', hoverColor = '', hasAction = true }) => {
  const classes = useStyles({
    size,
    color,
    hoverColor,
    hasAction
  });

  return (
    <div className={classes.informationDialogButton} onClick={action}>
      <HelpOutlineOutlinedIcon color="primary" classes={{ root: classes.iconRoot }} />
    </div>
  );
};

HelperIcon.propTypes = {
  action: PropTypes.func,
  size: PropTypes.number,
  color: PropTypes.string,
  hasAction: PropTypes.bool,
  hoverColor: PropTypes.string
};

export default HelperIcon;
